import { render, staticRenderFns } from "./PodsetnikOsobeDialog.vue?vue&type=template&id=91c910f6&scoped=true&"
import script from "./PodsetnikOsobeDialog.vue?vue&type=script&lang=ts&"
export * from "./PodsetnikOsobeDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c910f6",
  null
  
)

export default component.exports